<template>
  <div class="g_panel" :class="{ 'darkmode': darkMode, }" >
    <!-- header -->
    <div class="header g_panel-header">
      <span class="back icon-back" role="button" aria-label="back" tabindex="0" @click.stop="backHandler" />
      <h1 class="title">
        <img :src="require('@/assets/about/logo_s@2x.png')" alt="icon" class="taglogo">
        About
      </h1>
    </div>
    <!-- end header -->
    <div class="about g_scroll">
      <div class="about-con">
        <div class="banner">
          <div class="banner-text">
            <img v-if="!darkMode" :src="require('@/assets/about/logo@1x.png')" :srcset="require('@/assets/about/logo@2x.png') + ' 2x,' + require('@/assets/about/logo@3x.png') + ' 3x'" class="banner-text-logo" alt="banner-pic">
            <img v-else :src="require('@/assets/about/logo_dark@1x.png')" :srcset="require('@/assets/about/logo_dark@2x.png') + ' 2x,' + require('@/assets/about/logo_dark@3x.png') + ' 3x'" class="banner-text-logo" alt="banner-pic">
            <p class="des" :class="{des_en: lang === 'en'}">{{$t('about.slogen')}}</p>
          </div>
          <div class="banner-img_w" id="video-btn">
            <img @click="showVideo = true" :src="require('@/assets/about/play.png')" :srcset="require('@/assets/about/play@2x.png') + ' 2x,' + require('@/assets/about/play@3x.png') + ' 3x'" class="banner-play" alt="banner-pic">
            <img v-if="!darkMode" :src="require('@/assets/about/banner.png')" :srcset="require('@/assets/about/banner@2x.png') + ' 2x,' + require('@/assets/about/banner@3x.png') + ' 3x'" class="banner-img" alt="banner-pic">
            <img v-else :src="require('@/assets/about/banner_dark.png')" :srcset="require('@/assets/about/banner_dark@2x.png') + ' 2x,' + require('@/assets/about/banner_dark@3x.png') + ' 3x'" class="banner-img" alt="banner-pic">
          </div>
        </div>
        <div class="other">
          <div class="links">
            <a href="https://weibo.com/u/5471118198" class="item">
              <i class="icon icon-weibo"></i>
              LitteStar
            </a>
            <a href="https://twitter.com/LittleS04647858" class="item">
              <i class="icon icon-twitter"></i>
              LitteStar
            </a>
          </div>
          <div class="text">
            Build with ❤ by <a class="link" href="https://www.littlestarcloud.com" target="_blank" title="Alian">Alian</a>
          </div>
          <div class="text">
            Icons made by <a class="link" target="_blank" href="https://www.flaticon.com/packs/nfo@pixelbuddha.net" title="Pixel Buddha"> Pixel Buddha </a> from <a class="link" href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a>;
            <a class="link" target="_blank" href="https://www.iconfont.cn/collections/detail?cid=12938" title="iconfont"> zhwangart </a> from <a class="link" href="https://www.iconfont.cn/" title="Flatiiconfontcon">www.iconfont.cn</a>; Thank you for your contribution；
          </div>
          <CopyRight/>
        </div>
      </div>
    </div>
    <div class="video_w" id="video_w" :class="{show: showVideo}"  @click="showVideo = false" >
      <video class="video"  controls src="https://cdn.littlestarcloud.com/video2020-05-08.mp4" id="video">
        Your browser does not support the <code>video</code> element.
      </video>
      <div class="close_w" id="video-close">
        <img :src="require('@/assets/about/close.png')" :srcset="require('@/assets/about/close@2x.png') + ' 2x,' + require('@/assets/about/close@3x.png') + ' 3x'" class="close">
      </div>
    </div>
  </div>
</template>

<script>
import CopyRight from '@/components/CopyRight'
import { mapState } from 'vuex'

export default {
  components: {
    CopyRight,
  },
  data() {
    return {
      showVideo: false,
    }
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
    }),
  },
  methods: {
    backHandler() {
      this.$router.back()
    },
  },
}
</script>

<style lang="scss" scope>
.about{
  height: calc(100vh - 52px);
}
.about-con{
  max-width: 1246px;
  margin: 0 auto;
}

.header .logo{
  height: 57px;
  width: 216px;
  margin-top: 22px;
  margin-left: 16px;
}

.banner{
  padding-top: 106px;
  overflow: hidden;
}
.banner-text{
  float: left;
  padding-top: 138px;
  padding-left: 54px;
  width: 362px;
}
.banner-text-logo{
  width: 236px;
  height: 64px;
}
.banner-text .title{
  font-size: 48px;
  line-height: 48px;
  color: #484852;
  font-weight: bold;
}
.banner-text .des{
  font-size: 32px;
  color: #292929;
  line-height: 46px;
  margin-top: 25px;
  margin-bottom: 32px;
}
.banner-text .des_en{
  font-size: 46px;
  line-height: 50px;
  font-weight: bold;
}
.banner-text .btn{
  display: block;
  background: #2E7FFF;
  box-shadow: 0 2px 11px 0 rgba(255,255,255,0.18);
  border-radius: 999px;
  height: 56px;
  width: 192px;
  color: #fff;
  font-size: 16px;
  text-align: center;
  line-height: 56px;
  display: flex;
  align-items: center;
  text-decoration: unset;
  justify-content: center;
}
.banner-text .btn-icon{
  height: 18px;
  width: 14px;
  margin-right: 8px;
}
.banner-img_w{
  float: right;
  width: 649px;
  height: 469px;
  padding-right: 56px;
  position: relative;
  cursor: pointer;
}
.banner-img{
  width: 653px;
  height: 472px;
  transform: translate3d(0, 0, 0);
  transition: 0.6s cubic-bezier(0.38, 0.21, 0.09, 1.32);
}
.banner-play{
  position: absolute;
  left: 50%;
  top:50%;
  width: 56px;
  height: 56px;
  transform: translate(-50%, 200%);
  z-index: 10;
  visibility: hidden;
  opacity: 0;
  transition: 0.4s cubic-bezier(0.38, 0.21, 0.09, 1.32);
}
.banner-img_w:hover .banner-play{
  transform: translate3d(-50%, -50%, 0);
  visibility: visible;
  opacity: 1;
}
.banner-img_w:hover .banner-img{
  filter: blur(1px);
}

@media only screen and (max-width: 1400px) {
  .banner{
    padding-top: 60px;
  }
  .banner-text{
    float: none;
    margin: 0 auto;
    padding: 0;
    text-align: center;
    width: auto;
  }
  .banner-text-logo{
    font-size: 28px;
  }
  .banner-img_w{
    margin: 62px auto 0;
    float: none;
  }
}
.other{
  padding-bottom: 180px;
  .links {
    display: flex;
    justify-content: center;
    margin-bottom: 24px;
    margin-top: 94px;
    .item{
      display: block;
      text-decoration: none;
      height: 23px;
      width: 87px;
      color: #fff;
      line-height: 23px;
      text-align: center;
      background: #FB5B5B;
      border: 1px solid #FF9999;
      border-radius: 4px;
      margin: 0 8px;
      cursor: pointer;
      &:hover{
        background: rgb(255, 57, 57);
      }
    }
    .item:nth-child(2) {
      background: #00A7FF;
      border: 1px solid #50C2FE;
      border-radius: 4px;
      &:hover{
        background: #028eda;
      }
    }
  }
  .text{
    color: #939393;
    text-align: center;
    margin: 8px 0;
    .link{
      text-decoration: unset;
      color: #686868;
      font-weight: bold;
      &:hover{
        color: #00A7FF;
      }
    }
  }
}

.video_w{
  position: fixed;
  top: 0;
  left: 0;
  bottom:0;
  right: 0;
  z-index: 100;
  background: rgba(0,0,0,0.8);
  visibility: hidden;
  opacity: 0;
  transition: 0.2s ease;
}
.video_w.show{
  visibility: visible;
  opacity: 1;
}
.video_w .video{
  width: 90%;
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 100;
  transform: translate(-50%, -50%);
}
.video_w .close_w{
  height: 48px;
  width: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: rgba(255,255,255,0.18);
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translate(-50%, 0);
  cursor: pointer;
}
.video_w .close{
  display: block;
  width: 27px;
  height: 27px;
}

.darkmode{
  .des{
    color: #fff;
  }
  .text{
    color: #fff;
    .link{
      color: #fff;
    }
  }
}

</style>
